/**
 * authErrors — human-readable messages for Firebase Auth error codes.
 *
 * Isolated here so that components (SignIn.tsx etc.) do not import
 * `firebase/app` directly, satisfying the Capacitor readiness rule:
 * no firebase/* imports outside src/hooks/, src/features/auth/, src/lib/firebase.ts.
 */

import { FirebaseError } from 'firebase/app';

export function friendlyAuthError(err: unknown): string {
  if (err instanceof FirebaseError) {
    switch (err.code) {
      case 'auth/popup-blocked':
        return 'Your browser blocked the sign-in popup. Allow popups for this site and try again.';
      case 'auth/popup-closed-by-user':
        return 'Sign-in window was closed before finishing.';
      case 'auth/cancelled-popup-request':
        return 'Another sign-in is already in progress.';
      case 'auth/network-request-failed':
        return 'Network problem. Check your connection and try again.';
      case 'auth/user-disabled':
        return 'This account has been disabled. Contact support.';
      default:
        return err.message;
    }
  }
  return 'Sign-in failed. Try again.';
}
